<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Policies</v-tab>
    <v-tab @click="doFetchClaim">Claims</v-tab>
    <v-tab @click="doFetchAccount">Accounts</v-tab>
    <!-- <v-tab v-show="policyQueryTab" >{{ 'Query Policy' }}</v-tab>
    <v-tab v-show="claimQueryTab" >{{ 'Query Claim' }}</v-tab>
    <v-tab v-show="accountQueryTab" >{{ 'Query Account' }}</v-tab> -->
    <v-tab-item>
      <policy-list :fetchPolicy="fetchPolicy" :insdRefNo="insdRefNo" @resetTab="resetTab" @doQuery="doPolicyQuery"></policy-list>
    </v-tab-item>
    <v-tab-item>
      <claim-list :fetchClaim="fetchClaim" :insdRefNo="insdRefNo" @resetTab="resetTab"  @doQuery="doClaimQuery"></claim-list>
    </v-tab-item>
    <v-tab-item>
      <account-list :fetchAccount="fetchAccount" :insdRefNo="insdRefNo" @resetTab="resetTab" @doQuery="doAccountQuery"></account-list>
    </v-tab-item>
    <v-tab-item>
      <policy-form :ids="ids" @resetTab="resetTab"></policy-form>
    </v-tab-item>
    <v-tab-item>
      <claim-form :ids="ids" @resetTab="resetTab"></claim-form>
    </v-tab-item>
    <v-tab-item>
      <account-form :ids="ids" @resetTab="resetTab"></account-form>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import PolicyList from '../list/PolicyList'
import ClaimList from '../list/ClaimList'
import AccountList from '../list/AccountList'
import PolicyForm from '../form/PolicyForm'
import ClaimForm from '../form/ClaimForm'
import AccountForm from '../form/AccountForm'
import { ACCOUNTS_LOAD_DATA } from '@/store/types'

export default {
  data() {
    return {
      tabMenu: 0,
      policyQueryTab: false,
      claimQueryTab: false,
      accountQueryTab: false,
      fetchPolicy: false,
      fetchClaim: false,
      fetchAccount: false,
      ids: {
        insdRefNo: null
      }
    }
  },
  computed: {

  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('claimsInit')
      await this.$store.dispatch('claimsListingInit')
      await this.$store.dispatch('claimsRegisterInit')
      await this.$store.dispatch('accountsInit')
      await this.$store.dispatch('underwritingInit')
    },
    async resetTab(tab) {
      switch (tab) {
        case 4: {
          this.tabMenu = 3
          this.policyQueryTab = true
          this.claimQueryTab = true
          this.accountQueryTab = true
          this.fetchPolicy = false
          this.fetchClaim = false
          this.fetchAccount = false
          break
        }
        case 3: {
          this.tabMenu = 2
          this.policyQueryTab = true
          this.claimQueryTab = true
          this.accountQueryTab = true
          this.fetchPolicy = false
          this.fetchClaim = false
          this.fetchAccount = false
          break
        }
        case 2: {
          this.tabMenu = 1
          this.ids.insdRefNo = null
          this.policyQueryTab = true
          this.claimQueryTab = true
          this.accountQueryTab = true
          this.fetchPolicy = false
          this.fetchClaim = false
          this.fetchAccount = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.insdRefNo = null
          this.policyQueryTab = false
          this.claimQueryTab = false
          this.accountQueryTab = false
          this.fetchPolicy = true
          this.fetchClaim = false
          this.fetchAccount = false
        }
      }
    },
    async doPolicyQuery(data) {
      const convertPolicy = {
        item: {
          polNo: data.polNo,
          endtCnt: data.endtCnt,
          renCnt: data.renCnt
        }
      }
      await this.$store.dispatch('reviewPolicy', convertPolicy)

      this.ids.insdRefNo = this.insdRefNo
      this.policyQueryTab = true
      this.claimQueryTab = false
      this.accountQueryTab = false
      this.tabMenu = 3

      this.$router.push({ name: 'queryPolicy' })
    },
    async doClaimQuery(data) {
      const convertClaim = {
        clmNo: data.clmNo,
        query: false
      }
      await this.$store.dispatch('loadClaim', convertClaim)
      await this.$store.dispatch('claimEntryInit')

      this.ids.insdRefNo = this.insdRefNo
      this.policyQueryTab = false
      this.claimQueryTab = true
      this.accountQueryTab = false
      this.tabMenu = 4

      this.$router.push({ name: 'qClaimHeader', params: { claimNo: data.clmNo, clmNo: data.clmNo } })
    },
    async doAccountQuery(data) {
      const convertAccount = {
        branch: data.branch,
        acctNo: data.acctNo,
        type: data.tranType,
        docNo: data.docNo,
        fund: data.fund,
        suffix: data.acctNoSfx,
        rbcTran: data.rbcTran,
        osBalance: data.osBal,
        netAmount: data.netAmount
      }
      this.$store.commit(ACCOUNTS_LOAD_DATA, convertAccount)

      this.ids.insdRefNo = this.insdRefNo
      this.policyQueryTab = false
      this.claimQueryTab = false
      this.accountQueryTab = true
      this.tabMenu = 5

      this.$router.push({ name: 'accountsDetails', params: { accountData: data.item } })
    },
    doFetchClaim() {
      this.fetchClaim = true
      this.claimQueryTab = false
      this.policyQueryTab = false
      this.accountQueryTab = false
    },
    doFetchAccount() {
      this.fetchAccount = true
      this.claimQueryTab = false
      this.policyQueryTab = false
      this.accountQueryTab = false
    }
  },
  components: {
    PolicyList,
    PolicyForm,
    ClaimList,
    ClaimForm,
    AccountList,
    AccountForm
  },
  props: {
    insdRefNo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
